import Main from './Main.vue'
import Leilao from './components/Leilao'
import NovoLeilao from './components/NovoLeilao'
import VisualizarLeilao from './components/VisualizarLeilao'
import VisualizarLote from './components/VisualizarLote'
import MonitorComitente from './components/MonitorComitente'
import MonitorVoltarLote from './components/MonitorVoltarLote'
import MonitorVendasOnline from './components/MonitorVendasOnline'
import NovoLote from './components/NovoLote.vue'
import Relatorios from './components/Relatorios.vue'
import RelatorioSaida from './components/RelatorioSaida.vue'
import RelatorioSaidaArrematante from './components/RelatorioSaidaArrematante.vue'
import RelatorioLances from './components/RelatorioLances.vue'
import RelatorioLancesComitente from './components/RelatorioLancesComitente.vue'
import RelatorioResumo from './components/RelatorioResumo.vue'
import RelatorioFechamento from './components/RelatorioFechamento.vue'

export default [{
  path: 'leiloes',
  name: 'leiloes',
  component: Main,
  children: [
    {path: '/', component: Leilao, name: 'leilao'},
    {path: 'registro', component: NovoLeilao, name: 'leiloes.novo'},
    {path: ':id', component: VisualizarLeilao, name: 'leiloes.visualizar'},
    {path: ':id/edit', component: NovoLeilao, name: 'leiloes.editar'},
    {path: ':leilao/lotes/:id', component: VisualizarLote, name: 'lotes.visualizar'},
    {path: ':leilao/monitor-comitente', component: MonitorComitente, name: 'leilao.monitor-comitente'},
    {path: ':leilao/monitor-voltar-lote', component: MonitorVoltarLote, name: 'leilao.monitor-voltar-lote'},
    {path: ':leilao/monitor-vendas-online', component: MonitorVendasOnline, name: 'leilao.monitor-vendas-online'},
    {path: ':leilao/lotes/:id/edit', component: NovoLote, name: 'lotes.editar'},
    {path: ':leilao/lote/registro', component: NovoLote, name: 'lotes.novo'},
    {
      path: ':id/relatorios',
      component: Relatorios,
      name: 'leiloes.relatorios',
      children: [
        {path: 'saida', component: RelatorioSaida, name: 'leiloes.relatorios.saida'},
        {path: 'saida-arrematante', component: RelatorioSaidaArrematante, name: 'leiloes.relatorios.saida.arrematante'},
        {path: 'lances', component: RelatorioLances, name: 'leiloes.relatorios.lances'},
        {path: 'lances-comitente', component: RelatorioLancesComitente, name: 'leiloes.relatorios.lances.comitente'},
        {path: 'resumo', component: RelatorioResumo, name: 'leiloes.relatorios.resumo'},
        {path: 'fechamento', component: RelatorioFechamento, name: 'leiloes.relatorios.fechamento'}
      ]
    }
  ]
}
]



// WEBPACK FOOTER //
// ./src/app/website/leiloes/routes.js